import { styled } from "@mui/material";
import DirectoryItem from "../directory-item/directory-item.component";

const categories = [
  {
    id: 1,
    title: 'converse',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dais-h.appspot.com/o/converse.png?alt=media&token=b2a38916-3e32-4954-83a4-3c8628f46847',
    route: "shop/converse"
  },
  {
    id: 2,
    title: 'fila',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dais-h.appspot.com/o/pexels-enes-c%CC%A7elik-7748767.jpg?alt=media&token=394a03dd-cae0-410b-92d5-d63c6b775acd',
    route: "shop/fila"
  },
  {
    id: 3,
    title: 'reebok',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dais-h.appspot.com/o/reebok.png?alt=media&token=3c309257-78ea-4520-a7f0-753b7c134fab',
    route: "shop/reebok"
  },
  {
    id: 4,
    title: 'adidas',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dais-h.appspot.com/o/adidas.png?alt=media&token=35d82b0e-4b82-4602-96f2-eb20ab5481bd',
    route: "shop/adidas"
  },
  {
    id: 5,
    title: 'nike',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/dais-h.appspot.com/o/nike.png?alt=media&token=a4bfa8ce-e657-467c-8eef-6d202ec4f6f9',
    route: "shop/nike"
  },
];

const DirectoryContainer = styled('div')({
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
})

const Directory = () => {
    return (
      <>
        <DirectoryContainer>
          {categories.map((category) => (
            <DirectoryItem key={category.id} category={category} />
          ))}
        </DirectoryContainer>
      </>
    )
}

export default Directory;